import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  SimpleChange,
  OnChanges,
  Renderer2,
  OnDestroy
} from '@angular/core';
import {CommonUtils} from '../../utils/common.utils';

@Directive({
  selector: '[tableColumnsResize]'
})
export class ResizeDirective implements AfterViewInit, OnChanges, OnDestroy {

  constructor(private elRef: ElementRef, private renderer: Renderer2) { }

  @Input() isResizable = false;
  @Input() headerList = [];
  @Input() resizeTableOuter = false;
  @Output() updateResize = new EventEmitter();
  oldWidth: any;
  private mouseMove: any;
  private mouseUp: any;

  ngAfterViewInit() { }
  ngOnDestroy() {
    this.removeResizeTable();
  }

  ngOnChanges(changes: SimpleChanges) {
    const isResizable: SimpleChange = changes.isResizable;
    if (isResizable && isResizable.currentValue) {
      this.createResizeTable();
    } else {
      this.removeResizeTable();
    }
  }


  removeResizeTable() {
    CommonUtils.removeClass(this.elRef.nativeElement, 'table-resizable');
    const firstThElem = this.elRef.nativeElement.querySelectorAll('thead tr')[0];
    firstThElem.querySelectorAll('th').forEach((th: any) => {
      CommonUtils.removeClass(th, 'table-resizable-border');
      th.querySelectorAll('.table-resizable-grip').forEach((elm: any) => {
        if (elm) {
          elm.parentNode.removeChild(elm);
        }
      });
    });
    document.removeEventListener('mousemove', this.mouseMove);
    document.removeEventListener('mouseup', this.mouseUp);
  }

  createResizeTable() {
    let thElm;
    let startOffset;
    let currentWidth;
    let startX;
    let thNextElm;
    let startNextOffset;
    const minimumWidth = 90;
    let currentElmChildWidth = 30;
    let nextElmChildWidth = 0;

    CommonUtils.addClass(this.elRef.nativeElement, 'table-resizable');
    let totalStaticWidth = 0;
    let totalResizeColumns = 0;
    const firstThElem = this.elRef.nativeElement.querySelectorAll('thead tr')[0];
    firstThElem.querySelectorAll('th').forEach((th: any) => {
      const isStaticColumn = CommonUtils.hasClass(th, 'static-size');

      th.style.position = 'relative';
      if (!isStaticColumn) {
        totalResizeColumns++;
       // th.style.width = this.getInnerWidth(th) + 'px';
        CommonUtils.addClass(th, 'table-resizable-border');
        const grip = document.createElement('div');
        CommonUtils.addClass(grip, 'table-resizable-grip');
        th.appendChild(grip);

        this.renderer.listen(grip, 'mousedown', (e) => {
          thElm = th;
          currentElmChildWidth = thElm.firstElementChild.offsetWidth;
          startX = e.pageX;
          thNextElm = th.nextElementSibling;
          startOffset = parseInt(th.style.width, 10);
          if (thNextElm) {
            nextElmChildWidth = thNextElm.firstElementChild.offsetWidth;
            startNextOffset = parseInt(thNextElm.style.width, 10);
          }
          CommonUtils.addClass(this.elRef.nativeElement, 'table-resizable-resizing');
        });
      } else {
        totalStaticWidth = totalStaticWidth + th.offsetWidth;
      }

    });

    const adjustWidth = totalStaticWidth / totalResizeColumns;
    firstThElem.querySelectorAll('th').forEach((th: any) => {
      const isStaticColumn = CommonUtils.hasClass(th, 'static-size');
      if (!isStaticColumn) {
      //  th.style.width = this.getInnerWidth(th) + adjustWidth + 'px';
      }
    });

    this.mouseMove = (e) => {
      if (thElm) {
        const pageClc = e.pageX - startX;
        const elemNewWidth = startOffset + pageClc;
        if (thNextElm) {
          if (elemNewWidth > minimumWidth && elemNewWidth > currentElmChildWidth) {
            const elemNextWidth = startNextOffset - pageClc;
            if (elemNextWidth > minimumWidth && elemNextWidth > nextElmChildWidth) {
              thNextElm.style.width = elemNextWidth + 'px';
              thElm.style.width = elemNewWidth + 'px';
            }
          }
        } else {
          thElm.style.width = elemNewWidth + 'px';
        }
        currentWidth = elemNewWidth;
      }
    };

    this.mouseUp = (e) => {
      const newSizes = [];
      this.elRef.nativeElement.querySelectorAll('table th').forEach((th) => {
        newSizes.push({ id: th.id, width: parseInt(th.style.width, 10) });
      });

      CommonUtils.removeClass(this.elRef.nativeElement, 'table-resizable-resizing');
      if (thElm) {
        if ((!this.oldWidth && currentWidth) || (this.oldWidth > currentWidth || this.oldWidth < currentWidth)) {
          this.updateResize.emit({ id: thElm.id, width: currentWidth, row: newSizes });
        }
        this.oldWidth = currentWidth;
        currentWidth = undefined;
      }
      thElm = undefined;
      thNextElm = undefined;
    };

    document.addEventListener('mousemove', this.mouseMove);
    document.addEventListener('mouseup', this.mouseUp);
  }

  getInnerWidth(elem) {
    const style = window.getComputedStyle(elem);
    return elem.offsetWidth -
      parseFloat(style.paddingLeft) -
      parseFloat(style.paddingRight) -
      parseFloat(style.borderLeft) -
      parseFloat(style.borderRight) -
      parseFloat(style.marginLeft) -
      parseFloat(style.marginRight);
  }

}
